import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-right-down', 'CornerRightDown', [["path",{"d":"M13.973 19V9a4 4 0 0 0-4-4H5m14 9.22L13.973 19l-5.027-4.78","key":"svg-0"}]]);